"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Center = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var user_1 = require("../../model/user");
var service_1 = require("../../../library/base/service");
var Center = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(Center, _super);
    function Center() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '用户中心';
        _this.code = '101056';
        _this.desc = '';
        _this.requestParams = new user_1.CenterRequest();
        // public responseParams: LoginRequest;
        _this.method = fetch_1.Methods.POST;
        return _this;
        // public security = false;
    }
    return Center;
}(service_1.BaseService));
exports.Center = Center;
//# sourceMappingURL=center.js.map